import * as actionTypes from './types';
import { request } from '@/request';

export const crud = {
  resetState:
    (props = {}) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.RESET_STATE,
      });
    },
  resetAction:
    ({ actionType }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.RESET_ACTION,
        keyState: actionType,
        payload: null,
      });
    },
  currentItem:
    ({ data }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.CURRENT_ITEM,
        payload: { ...data },
      });
    },
  currentAction:
    ({ actionType, data }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.CURRENT_ACTION,
        keyState: actionType,
        payload: { ...data },
      });
    },
  list:
    ({ entity, tenant ,options = { page: 1 } }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.REQUEST_LOADING,
        keyState: 'list',
        payload: null,
      });

      const currentTenant = tenant;
            const multiTenantEntity = `../${currentTenant}/api/v1/${entity}`;

      const limit = options.limit || 10;
      const offset = (options.page - 1) * limit;

      const adaptedOptions = {
        ...options,
        limit: limit,
        offset: offset,
        pais: 1,
      };

      let data = await request.list({ entity: multiTenantEntity, options: adaptedOptions });

      let currentPage = 1;
      let currentTotal = 1;

      if (data.success === true) {
        if (data.pagination === undefined || data.pagination === null) {
        } else {
                  currentPage = parseInt(data.pagination.page, 10);
          currentTotal = parseInt(data.pagination.count, 10);
        }

        const result = {
          items: data.result,
          pagination: {
            current: currentPage,
            pageSize: 10,
            showSizeChanger: false,
            total: currentTotal,
          },
        };
        dispatch({
          type: actionTypes.REQUEST_SUCCESS,
          keyState: 'list',
          payload: result,
        });
      } else {
        dispatch({
          type: actionTypes.REQUEST_FAILED,
          keyState: 'list',
          payload: null,
        });
      }
    },
  create:
    ({ entity, tenant, options = { page: 1 }, jsonData }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.REQUEST_LOADING,
        keyState: 'create',
        payload: null,
      });

      const multiTenantEntity = `../${tenant}/api/v1/${entity}`;

      const limit = options.limit || 10;
      const offset = (options.page - 1) * limit;

      const adaptedOptions = {
        ...options,
        limit: limit,
        offset: offset,
        pais: 1,
      };

      let data = await request.create({ entity: multiTenantEntity, options: adaptedOptions, jsonData });

      if (data.success === true) {
        dispatch({
          type: actionTypes.REQUEST_SUCCESS,
          keyState: 'create',
          payload: data.result,
        });

        dispatch({
          type: actionTypes.CURRENT_ITEM,
          payload: data.result,
        });
      } else {
        dispatch({
          type: actionTypes.REQUEST_FAILED,
          keyState: 'create',
          payload: null,
        });
      }
    },
  read:
    ({ entity, id, tenant, options = { page: 1 } }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.REQUEST_LOADING,
        keyState: 'read',
        payload: null,
      });


      const multiTenantEntity = `../${tenant}/api/v1/${entity}`;

      const limit = options.limit || 10;
      const offset = (options.page - 1) * limit;

      const adaptedOptions = {
        ...options,
        limit: limit,
        offset: offset,
        pais: 1,
      };

      let data = await request.read({ entity: multiTenantEntity, id, options: adaptedOptions });

      if (data.success === true) {
        dispatch({
          type: actionTypes.CURRENT_ITEM,
          payload: data.result,
        });
        dispatch({
          type: actionTypes.REQUEST_SUCCESS,
          keyState: 'read',
          payload: data.result,
        });
      } else {
        dispatch({
          type: actionTypes.REQUEST_FAILED,
          keyState: 'read',
          payload: null,
        });
      }
    },
  update:
    ({ entity, tenant, id, jsonData }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.REQUEST_LOADING,
        keyState: 'update',
        payload: null,
      });

      const multiTenantEntity = `../${tenant}/api/v1/${entity}`;

      let data = await request.update({ entity: multiTenantEntity, id, jsonData });

      if (data.success === true) {
        dispatch({
          type: actionTypes.REQUEST_SUCCESS,
          keyState: 'update',
          payload: data.result,
        });
        dispatch({
          type: actionTypes.CURRENT_ITEM,
          payload: data.result,
        });
      } else {
        dispatch({
          type: actionTypes.REQUEST_FAILED,
          keyState: 'update',
          payload: null,
        });
      }
    },
  delete:
    ({ entity, tenant, id }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.REQUEST_LOADING,
        keyState: 'delete',
        payload: null,
      });


      const multiTenantEntity = `../${tenant}/api/v1/${entity}`;

      // Eliminamos el bloque de options porque no se usa para borrar
      let data = await request.delete({ entity: multiTenantEntity, id });

      if (data.success === true) {
        dispatch({
          type: actionTypes.REQUEST_SUCCESS,
          keyState: 'delete',
          payload: data.result,
        });
      } else {
        dispatch({
          type: actionTypes.REQUEST_FAILED,
          keyState: 'delete',
          payload: null,
        });
      }
    },
  search:
    ({ entity, tenant, options = { page: 1 } }) =>
    async (dispatch) => {
      dispatch({
        type: actionTypes.REQUEST_LOADING,
        keyState: 'search',
        payload: null,
      });

   
      const multiTenantEntity = `../${tenant}/api/v1/${entity}`;

      const limit = options.limit || 10;
      const offset = (options.page - 1) * limit;

      const adaptedOptions = {
        ...options,
        limit: limit,
        offset: offset,
        pais: 1,
      };

      let data = await request.search({ entity: multiTenantEntity, options: adaptedOptions });

      if (data.success === true) {
        dispatch({
          type: actionTypes.REQUEST_SUCCESS,
          keyState: 'search',
          payload: data.result,
        });
      } else {
        dispatch({
          type: actionTypes.REQUEST_FAILED,
          keyState: 'search',
          payload: null,
        });
      }
    },
};